// extracted by mini-css-extract-plugin
export var resizer = "_ha-0";